<script lang="ts">
    import CountryPicture from '$components/CountryPicture.svelte';
    import ParticipantAvatar from '$components/ParticipantAvatar/ParticipantAvatar.svelte';
    import FollowButton from '$components/FollowButton/FollowButton.svelte';
    import { getContainer } from '$components/Context/ContainerContext.js';
    import {
        FollowButtonFragmentDoc,
        ParticipantAvatarFragmentDoc,
        ParticipantCardFragmentDoc,
        type ReactionAuthorFragment,
    } from '$gql/graphql.js';
    import { getReactionsData } from './Utils';
    import ParticipantCard from '$components/ParticipantCard/ParticipantCard.svelte';
    import { useFragment } from '$gql';

    const { intl, lang } = getContainer();

    export let author: ReactionAuthorFragment;
    export let type: string;
    export let currentUserId: number | null;
    $: participant = author;
    $: reactionsData = getReactionsData($lang);
    $: _type = type as keyof typeof reactionsData.images;
</script>

<div
    class={'flex space-x-4 mt-2 cursor-pointer rounded-md hover:bg-gray-300 p-2 transition-colors ease-in-out duration-500 border-b border-gray-300 last:border-none'}
>
    <span class={'relative flex items-end justify-end'}>
        <ParticipantCard
            participant={useFragment(ParticipantCardFragmentDoc, participant)}
        >
            <ParticipantAvatar
                participant={useFragment(ParticipantAvatarFragmentDoc, participant)}
                dontWrapInLink
                size={'md'}
            />
        </ParticipantCard>
        <img
            class={'absolute h-8 w-8'}
            src={reactionsData.images[_type]}
            alt={reactionsData.labels[_type]}
        />
    </span>
    <div class={'flex-grow'}>
        <div class={'flex items-start justify-between gap-x-2'}>
            <div>
                <ParticipantCard
                    participant={useFragment(ParticipantCardFragmentDoc, participant)}
                >
                    <a
                        class={'line-clamp-2 break-all text-brand-blue no-underline hover:underline'}
                        data-sveltekit-reload
                        href={participant.participantProfileLink}
                        target={'_blank'}
                    >
                        {participant.participantName}
                    </a>
                </ParticipantCard>

                {#if participant.__typename === 'User'}
                    <div class={'line-clamp-3 text-gray-600 text-sm mt-2'}>
                        {participant.participantTitle}
                    </div>
                {:else}
                    <div class={'flex items-center'}>
                        {#if participant.country}
                            <CountryPicture
                                class={'mr-2'}
                                size="24"
                                country={participant.country}
                            />
                        {/if}
                        {#if participant.city || participant.country}
                            <span class={'text-sm text-gray-600'}>
                                {intl().countryLabel(participant.country)}
                                {participant.city ? ` / ${participant.city}` : ''}
                            </span>
                        {/if}
                    </div>

                    {#if participant.category}
                        <div
                            class={'text-sm w-full line-clamp-1 text-gray-600 break-all'}
                        >
                            {participant.category.category}
                        </div>
                    {/if}
                {/if}
            </div>
            {#if !(participant.__typename === 'User' && participant.id === currentUserId)}
                <FollowButton
                    target={useFragment(FollowButtonFragmentDoc, participant)}
                    class="btn rounded-full btn-sm shadow"
                    followedClassName="btn-blue"
                    unfollowedClassName="btn-default text-brand-blue border border-brand-blue"
                />
            {/if}
        </div>
    </div>
</div>
